import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { StaffFormComponent } from '../staff-form/staff-form.component';
import { StaffViewComponent } from '../staff-view/staff-view.component';

export type StaffStatus      = 'Active' | 'Inactive' | 'On Leave' | 'Resigned' | 'Terminated';
export type StaffType        = 'Teaching' | 'Non-Teaching' | 'Administrative' | 'Support';
export type StaffGender      = 'Male' | 'Female' | 'Other';
export type EmploymentType   = 'Permanent' | 'Contractual' | 'Part-time' | 'Guest';

@Component({
	selector: 'app-staff-list',
	imports: [CommonModule, FormsModule, StaffFormComponent, StaffViewComponent],
	templateUrl: './staff-list.component.html',
	styleUrl: './staff-list.component.scss',
})
export class StaffListComponent {
  dataService: any = inject(DataService);

  base = 'staff';		// important for API calls

	loading = false;
  isEdit = false;
  isView = false;
	allData: any = [];
  allxData: any = [];
  selStaff: any = null;
  urType = '';    // 'T', 'K', 'P' Trial, KYC and Paid users
	btnClick: string = "";
  pullme = false;

  searchQuery   = '';
  filterType:    StaffType | ''   = '';
  filterDept     = '';
  filterStatus:  StaffStatus | '' = '';
  filterEmpType: EmploymentType | '' = '';

  readonly staffTypes:      StaffType[]       = ['Teaching', 'Non-Teaching', 'Administrative', 'Support'];
  readonly employmentTypes: EmploymentType[]  = ['Permanent', 'Contractual', 'Part-time', 'Guest'];
  readonly statusOptions:   StaffStatus[]     = ['Active', 'Inactive', 'On Leave', 'Resigned', 'Terminated'];
  readonly departments = [
    'Science', 'Mathematics', 'English', 'Hindi', 'Social Science',
    'Commerce', 'Arts', 'Computer Science', 'Physical Education',
    'Administration', 'Accounts & Finance', 'Library', 'Laboratory',
    'Hostel', 'Transport', 'Sports', 'Music & Arts', 'Other',
  ];
  readonly designations: Record<StaffType, string[]> = {
    'Teaching':        ['Principal', 'Vice Principal', 'Head of Department', 'Senior Teacher', 'Teacher', 'Assistant Teacher', 'Guest Faculty', 'Lecturer', 'Professor', 'Associate Professor'],
    'Non-Teaching':    ['Librarian', 'Lab Assistant', 'Lab Technician', 'Computer Operator', 'Clerk', 'Accountant', 'Cashier', 'Receptionist', 'Counsellor'],
    'Administrative':  ['Administrator', 'Deputy Administrator', 'HR Manager', 'Office Superintendent', 'Office Assistant', 'Data Entry Operator'],
    'Support':         ['Peon', 'Guard / Security', 'Gardener', 'Sweeper', 'Cook', 'Driver', 'Bus Attendant', 'Electrician', 'Plumber'],
  };
  readonly subjectOptions = this.dataService.subjects;

	async ngOnInit() {
		this.loading = true;
    await this.dataService.getAllRecords(this.base).then((res: any) => {
      if(res && res.length) {
        this.allData = res;
        this.allxData = res;
      }

      // for(let i=0; i<this.allData.length; i++) {
			// 	this.allData[i].user_role = JSON.parse(this.allData[i].user_role);
			// }
			this.loading = false;
    });
	}
	getAvatarColor(id: number): string {
    const colors = ['#1a3a6b','#059669','#d97706','#7c3aed','#0284c7','#dc2626','#0d9488','#be185d'];
    return colors[id % colors.length];
  }
	getInitials(s: any): string {
		return [(s.first_name ?? ' ')[0], (s.last_name ?? ' ')[0]].join('').toUpperCase();
	}

  newClick() {
    this.isView = false;
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'staff',
      action: 'addnew', 
      data: null,
      emp_code: this.allData?.length + 1
    });
  }

  editClick(myData: any) {
    this.isView = false;
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'staff',
      action: 'edit', data: myData
    });
  }

  viewClick(myData: any) {
    this.isView = true;
    this.selStaff = myData;
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response: any) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error: any) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}
}
